module.exports = __webpack_public_path__ + "img/744.7b029d4c.jpg";